module.exports = {
          srcSet: __webpack_public_path__ + "2f5aa3a1a947e9a9aeea4ee4e281bb80-1920.webp"+" 1920w",
          images:[ {path: __webpack_public_path__ + "2f5aa3a1a947e9a9aeea4ee4e281bb80-1920.webp",width: 1920,height: 50}],
          src: __webpack_public_path__ + "2f5aa3a1a947e9a9aeea4ee4e281bb80-1920.webp",
          toString:function(){return __webpack_public_path__ + "2f5aa3a1a947e9a9aeea4ee4e281bb80-1920.webp"},
          
          width: 1920,
          height: 50
        }